import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { LanguageType } from '../enum/app.enum';

@Pipe({
  name: 'newsDate',
  standalone: true,
  pure: true,
})
export class NewsDatePipe implements PipeTransform {
  transform(value: Date | undefined, lang: LanguageType): string {
    if (!value || !lang) return '';

    switch (lang) {
      case LanguageType.En:
        return formatDate(value, 'MMMM d, yyyy', 'en-US');
      case LanguageType.Fr:
        return formatDate(value, 'd MMMM yyyy', 'fr-FR');
      case LanguageType.Jp:
      case LanguageType.Ko:
        return formatDate(value, 'yyyy.MM.dd', 'ko-KR');
    }
  }
}
